export const DEFAULT_PANEL_RATIO = 0.35;
